import React from 'react';
import { CheckCircleIcon, ShieldCheckIcon, ClockIcon, AwardIcon } from 'lucide-react';
export function TrustBadges() {
  const badges = [{
    icon: CheckCircleIcon,
    label: '99.9% Uptime',
    value: 'Guaranteed'
  }, {
    icon: ShieldCheckIcon,
    label: 'Enterprise Security',
    value: 'SOC 2 Certified'
  }, {
    icon: ClockIcon,
    label: '24/7 Support',
    value: 'Always Available'
  }, {
    icon: AwardIcon,
    label: '10,000+ Calls',
    value: 'Handled Daily'
  }];
  return <section className="w-full bg-[#1A1A1A] py-16" data-id="element-303">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-304">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-305">
          {badges.map((badge, index) => {
          const Icon = badge.icon;
          return <div key={index} className="text-center" data-id="element-306">
                <div className="w-16 h-16 bg-[#F1B530]/10 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-[#F1B530]/20" data-id="element-307">
                  <Icon className="w-8 h-8 text-[#F1B530]" data-id="element-308" />
                </div>
                <div className="font-['Poppins'] text-2xl font-bold text-[#F5F5F5] mb-1" data-id="element-309">
                  {badge.label}
                </div>
                <div className="font-['Inter'] text-sm text-[#A0A0A0]" data-id="element-310">
                  {badge.value}
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}